import { Box, Container, Text, Flex, Button } from 'theme-ui';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';
import ImgLoader from '~/components/Generic/ImgLoader';

const SimpleHero = ({ title, subtitle, body, image, cta }) => {
  return (
    <Flex
      as="section"
      sx={{
        '--image-height': ['60.6rem', '53.5rem', '66.6rem'],
        flexFlow: 'column nowrap',
        position: 'relative',
        textAlign: [null, null, 'center'],
        pb: ['8.4rem', '6rem', '7.5rem'],
        backgroundColor: 'white',
      }}
    >
      <Container pt={['10.3rem']} pb={0}>
        {subtitle ? (
          <Text as="p" variant="text.h5" mb={2} pl={['0.4em', null, 0]}>
            {subtitle}
          </Text>
        ) : null}

        <Text
          as="h1"
          variant="h1"
          sx={{
            fontSize: ['clamp(7rem, 18vw, 7.8rem)', 'min(11.2rem, 19vw)', 6],
            textAlign: [null, null, 'center'],
            mb: ['5.3rem', '6.3rem', '6rem'],
            maxWidth: [null, null, 'min-content'],
            mx: [null, null, 'auto'],
          }}
        >
          {title}
        </Text>
      </Container>

      <Container sx={{ order: [null, 2, 0], display: ['none', 'block'], pt: [0, '4.8rem', 0], pb: [0, null, '7rem'] }}>
        <Text as="p" sx={{ maxWidth: [null, '57rem', '67rem'], mx: [null, null, 'auto'] }}>
          {body}
        </Text>

        {cta && (
          <Box>
            {cta.url ? (
              <Button
                as="a"
                href={cta.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  variant: ['buttons.primary'],
                  minWidth: ['min(36.6rem, 100%)', 0, null],
                  mx: [null, null, 'auto'],
                  mt: '4rem',
                }}
              >
                {cta.text}
              </Button>
            ) : (
              <Button
                as={Link}
                to={`${cta.page.slug}/`}
                sx={{
                  variant: ['buttons.primary'],
                  minWidth: ['min(36.6rem, 100%)', 0, null],
                  mx: [null, null, 'auto'],
                  mt: '4rem',
                }}
              >
                {cta.text}
              </Button>
            )}
          </Box>
        )}
      </Container>

      <Container variant="fullWidth" sx={{ px: [null, null, 'var(--horizontal-inset)'] }}>
        <Box
          sx={{
            borderRadius: ['25px 0 75px', null, '50px 0 180px'],
            WebkitMaskImage: '-webkit-radial-gradient(white, black)',
            overflow: 'hidden',
            height: 'var(--image-height)',
          }}
        >
          {image.file.contentType.split('/')[0] === 'video' ? (
            <video
              muted
              sx={{
                height: '100%',
                minHeight: '300px',
                width: '100%',
                objectFit: 'cover',
              }}
              loop
              playsInline
              autoPlay
            >
              <source src={image.file.url} type={image.file.contentType} />
            </video>
          ) : (
            <ImgLoader
              image={image}
              sx={{
                objectPosition: 'top',
                height: '100%',
                minHeight: '300px',
                height: 'var(--image-height)',
                width: '100%',
              }}
            />
          )}
        </Box>
      </Container>
    </Flex>
  );
};

SimpleHero.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  body: PropTypes.string,
  image: PropTypes.shape({
    fluid: PropTypes.object.isRequired,
  }).isRequired,
};

export default SimpleHero;
